import React from "react";

const VideoEmbed = ({ url }) => {
  return (
    <div className="relative overflow-hidden aspect-ratio">
      <iframe
        title={`video-${url}`}
        className="absolute pin-t pin-l w-full h-full border-0"
        src={url}
        allowfullscreen
      />
    </div>
  );
};

export default VideoEmbed;
